export default "__VITE_ASSET__CCTQ0Bnb__"